"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BankTile", {
  enumerable: true,
  get: function () {
    return _bankTile.BankTile;
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function () {
    return _Footer.Footer;
  }
});
Object.defineProperty(exports, "Footer2", {
  enumerable: true,
  get: function () {
    return _Footer2.Footer2;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function () {
    return _index2.Header;
  }
});
Object.defineProperty(exports, "PrivacyPolicyDrawer", {
  enumerable: true,
  get: function () {
    return _index3.PrivacyPolicyDrawer;
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function () {
    return _index.Search;
  }
});
Object.defineProperty(exports, "TermsConditionsDrawer", {
  enumerable: true,
  get: function () {
    return _index4.TermsConditionsDrawer;
  }
});
Object.defineProperty(exports, "footerLogos", {
  enumerable: true,
  get: function () {
    return _Footer.footerLogos;
  }
});
var _bankTile = require("./components/bankTile/bankTile");
var _Footer = require("./components/Footer/Footer");
var _Footer2 = require("./components/Footer2/Footer");
var _index = require("./components/search/index");
var _index2 = require("./components/header/index");
var _index3 = require("./components/consentDrawers/PrivacyPolicyDrawer/index");
var _index4 = require("./components/consentDrawers/TermsConditionsDrawer/index");